exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{font-size:16px}html *{box-sizing:border-box;-webkit-font-smoothing:antialiased}body{font-family:Source Sans Pro,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif;background:#7ea6b6;background-image:radial-gradient(circle,#7ea6b6 0,#1a5b72 100%);background-size:100vw 100vh;background-attachment:fixed;min-height:100vh;color:#646f79}#app{padding:70px 20px 20px 60px}.nav-item img{margin-bottom:.25rem;margin-top:.25rem;width:100px;height:auto}.hide{display:none}label.label{font-weight:500}.container>h3{font-size:1.25rem;margin:0 0 .5rem;border-bottom:1px solid #dbdbdb}.main-stage{background:#fff;border-radius:4px;padding:20px}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-7bdcb0a4!./~/sass-loader?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 470
// module chunks = 22